import React from 'react';

import { useParams } from 'react-router';
import { Product } from '@/modules';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { investorActions } from '@/store/investor';
import { useScrollToTop } from '@/hooks';

export const EditProductPage = () => {
  const dispatch = useDispatch();
  const { investor } = useSelector((state) => state);
  const { data } = useQuery({
    queryKey: ['fetchInvestorProfile'],
    queryFn: () => investorActions.fetchInvestorProfile(id, dispatch),
    enabled: !investor.accountStatus
  });

  useScrollToTop([], { behavior: 'auto' });

  const { id, productId } = useParams();

  return <Product adminView adminEditView investorId={id} productId={productId} />;
};
